import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  TooltipV2,
  TooltipTrigger,
  TooltipContent,
} from '../TooltipV2/TooltipV2';
import { BrideHistoryWarningReason } from '../../api/MeetingsAPI';
import { brideHistoryWarningTranslationKey } from '../../shared/brideHistoryWarningMessage';

type Props = {
  reason?: BrideHistoryWarningReason | null;
  className?: string;
  iconClassName?: string;
};

const BrideHistoryWarningIcon: React.FC<Props> = ({
  reason,
  className = '',
  iconClassName = 'h-4 w-4',
}) => {
  const { t } = useTranslation();
  const message = t(brideHistoryWarningTranslationKey(reason));

  return (
    <TooltipV2>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center text-yellow-500 hover:text-yellow-600 focus:outline-none ${className}`}
          aria-label={message}
          onClick={(e) => e.stopPropagation()}
        >
          <AlertTriangle className={iconClassName} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={4}
        className="max-w-xs z-[500] border-0 bg-gray-800 px-2 py-1.5 text-left text-xs leading-snug text-white shadow-lg"
      >
        {message}
      </TooltipContent>
    </TooltipV2>
  );
};

export default BrideHistoryWarningIcon;
